<template>
	<aside class="app-aside" :class="hide_menu">
        <div class="tree-menu" v-show="showMenu" v-loading="loading">
            <div class="titleBar">项目监管系统</div>
            <l-tree :treedata="treedata" :currentNodeName="currentNodeName" @click.native='toggle'></l-tree>
            <!--<div v-if="roleId == 'unit' || roleId == 'BuildUnit' && showJump" class="titleBar jump" @click="jumpBeer()">福建省电子档案试点项目公示平台</div>-->
            <!--<div class="titleBar">海迈建设工程智慧服务平台</div>-->
            <!--<ul class="jump">-->
                <!--<li><a href="http://www.efileyun.com" target="_blank">海迈施工内业资料电子档案</a></li>-->
                <!--<li v-if="showSystem"><a href="#" @click="showEnvironment">海迈环境监测系统</a></li>-->
                <!--<li><a href="#" @click="showDialog">信用加分了解一下</a></li>-->
            <!--</ul>-->
        </div>
	</aside>
</template>
<script>
import { API_Common, API_CONST } from "@/api/api.js"
import openByPost from "@/tool/openByPost.js"
import menuUnit from "@/static/js/menu_unit.js"
import menuMan from "@/static/js/menu_man.js"
export default {
	props: ["currentNodeName"],
	mounted() {
        this.id = this.$route.query.id;
		// history.pushState(null, null, document.URL);
		let roleType = "";
		if (localStorage.userinfo) {
			let userinfo = JSON.parse(localStorage.userinfo);
			// if (userinfo.roleId == "pm") {
			// 	this.treedata = menuMan;
			// } else if (userinfo.roleId == "BuildUnit") {
			// 	this.treedata = menuUnit;
			// }
			this.treedata = menuMan;
			// 接口树
			this.loading = true;
			let me = this;
			API_Common.getTreeData(userinfo.roleId).then(res => {
				this.treedata = res.menus;
				if (userinfo.userId == "156220149") {
					this.treedata.push({ "id": "toVedio", "data": { "menuName": "视频监控查看", "skipCode": "toVedio", "menuCode": "toVedio", "to": "" }, "children": [] });
				}
                if (userinfo.userId == "746502808") {
                    this.treedata.push({ "id": "toVedio", "data": { "menuName": "视频监控查看", "skipCode": "toVedio1", "menuCode": "toVedio", "to": "" }, "children": [] });
                }
                if(me.id != undefined && me.id != ""){
                    for(let i = 0 ;i< me.treedata.length;i++){
                        if(me.treedata[i].data.skipCode != me.id){
                            if(me.treedata[i].children.length != 0){
                                if(this.flag){
                                    this.parent[this.index] = me.treedata[i].data.menuName;
                                }
                                this.getDate(me.treedata[i].children);
                            }
                        }
                        this.index = 0;
                    }
                }
				this.loading = false;
			})
		} else {
			this.$router.replace('/login')
		}
        if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'local') {
            this.showSystem = true;
            this.showJump = false;
        }else{
            this.showSystem = false;
            this.showJump = true;
        }
        let userinfo = JSON.parse(localStorage.getItem("userinfo"));
        this.roleId = userinfo.roleId;
	},
	data() { //data : function(){return{...}} //https://segmentfault.com/q/1010000005918462
		return {
			treedata: [],
			showMenu: true,
			currentNode: "",
			loading: false,
            id:"",
            parent:[],
            index:0,
            flag:true,
            showSystem:true,
            showJump: false,
            roleId: ''
		}
	},
	watch: {
		currentNodeName() {//用户点击标签页，左侧树也要同改变焦点 currentNodeName = menuCode
		}
	},
	methods: {
		toggleMenu: function() {
			this.showMenu = !this.showMenu;
			this.$emit("toggleMenu");
		},
		toggle: function(e) {
			if (e.target.nodeName && (e.target.nodeName.toUpperCase() != "A" && e.target.nodeName.toUpperCase() != "I"))
				return;
			let $anode = "";
			if (e.target.nodeName.toUpperCase() == "A")
				$anode = $(e.target);
			else if (e.target.nodeName.toUpperCase() == "I")
				$anode = $(e.target).parents("a");
			if ($anode.hasClass("folder")) {
				$anode.children(".icon").children("i").toggleClass("fa-rotate-90")
				$anode.parent().children("ul").slideToggle();
			} else {
				if ($anode.attr("href") == "javascript:void(0)") {
					return false;
				}
				if ($anode.attr('menuCode') == "materialOriginPublic") {
					// 跳转到公共平台
					$anode.blur();
					window.open(API_CONST.publicShow);
					return;
				}
				let linode = $anode.parent()[0];
				// console.log($anode.attr("href"))
				let href = "";
				if ($anode.attr("href").indexOf("#") > -1) {
					href = $anode.attr("href").split("#")[1];
				}
				else {
					href = $anode.attr("href");
				}
				this.$emit("passLinkVal", [{ linkName: $anode.html(), menuCode: $anode.attr('menuCode'), href: href }]);
			}
		},
        learn(){
		    this.$emit("learn")
        },
        getDate(data){
            this.index++;
            for(let j = 0;j< data.length;j++){
                if(data[j].data.skipCode != this.id){
                    if(data[j].children.length != 0){
                        if(this.flag){
                            this.parent[this.index] = data[j].data.menuName;
                        }
                        this.getDate(data[j].children);
                        this.index--;
                    }
                }else{
                    this.flag = false;
                    let str = [{linkName: data[j].data.menuName, menuCode: data[j].data.menuCode, href: data[j].data.to}];
                    this.$emit("showJump",str);
                }
            }
        },
        showTarge(){
            this.$nextTick(function() {
                for(let i = 0;i<this.parent.length;i++){
                    $('li a[name="'+this.parent[i]+'"]').next()[0].style.display = "block";
                }
            });
        },
        showDialog(){
            this.$emit("showAd");
        },
        showEnvironment(){
            this.$emit("showEnvironment");
        },
        jumpBeer() {
            let userinfo = JSON.parse(localStorage.getItem("userinfo"));
            API_Common.jump2Seer({"userId":userinfo.userId, "unitId":userinfo.unitId,"role":userinfo.roleId,"unitName":userinfo.roleName}).then(res => {
                window.open(API_CONST.SeerAddress + '?from=NOVA&str=' + JSON.stringify(res))
            });
        }
	},
	computed: {
		show_icon: function() {
			return { fa: true, "fa-angle-double-left": this.showMenu, "fa-angle-double-right": !this.showMenu }
		},
		hide_menu: function() {
			return { "hide-menu": !this.showMenu }
		}
	},
	components: {
		"l-tree": {
			name: "sub-tree",
			props: ["treedata", "currentNodeName"],
			data() {
				return {
					show: true,
				}
			},
			methods: {
				linkclick(data) {
					let skipCode = data.skipCode;
					if (skipCode == "toVedio") {
						let videoJson = { proId: "f59b078559b4bb44015a5f7816131bb5", source: "remaius", "code": "TPShy6CsDqykShYBDCc4Jbe3+2mU5WcOIKxssoL9sdvtx6f/xbLlC/hYwqyLKcLeaTrcKj82lQMgWzFVuiymS1+0Yc1H0k52iFbnMqXRB7Q2wyV8xJx8WYF6gI7xBfyr6KjKadrcdB5G3eC0c9pmk4hPZ3MXsbKGa5XckrYxQvc=" }
						openByPost("http://118.31.2.158:8888/video", videoJson);
						return;
					}
                    if (skipCode == "toVedio1") {
                        let videoJson = { proId: "f59b07855fd49673015fd86ca8791e78", source: "remaius", "code": "UCE0Nm0QPlVFVfFw8XzZb/gecT49s+DufkSMPO+LhOA6umzwGL0cDvZq/qEDJlInUy3KP+20Nlml3wc0xEKtSu2IYVWyzu1MasBL1GSZLPYAaXHNTCYPsZ2vHH6lz3wsLcgt8AyrvRDSLA/yxa/dmo8x8aMJ2KaEh2cm6ooS2rI=" }
                        openByPost("http://118.31.2.158:8888/video", videoJson);
                        return;
                    }
					let userId = JSON.parse(localStorage.userinfo).userId;
					let time = new Date().getTime();
					let nowtime = new Date().getTime();
					let text = userId + nowtime + "nova2275337!@#";
					API_Common.getMD5(encodeURIComponent(text)).then(res => {
						let json = {
							"_eosFlowAction": "login",
							"param/novaUserid": userId,
							"param/novaNowtime": nowtime,
							"param/novaMenuid": skipCode,
							"param/novaCiphertext": res //MD5
						}
						openByPost(API_CONST.originalAdress, json);
						return false;
					});
				},
			},
			template: `<ul>
							<li v-for='(menu,index) in treedata' :key="index" :class="{active:menu.data.menuCode==currentNodeName } ">
								<a :name='menu.data.menuName' :text='menu.data.menuName' v-if=' menu.children.length>0 ' href="javascript:void(0)" class="folder" style='dispaly:block'>
									<span class='icon' v-if='menu.children.length>0'><i class='fa fa-caret-right'></i></span>
									<span class='icon' v-else><i class='fa fa-link'></i></span>
									{{menu.data.menuName}}
								</a>
							 	<router-link :name='menu.data.menuName' :text='menu.data.menuName' v-else-if="menu.data.to && menu.data.to!=''" :to="menu.data.to" replace :menuCode="menu.data.menuCode" >{{menu.data.menuName}}</router-link>
								<a :name='menu.data.menuName' :text='menu.data.menuName' v-else-if='menu.data.skipCode.length>0' href="javascript:void(0)" @click="linkclick(menu.data)">{{menu.data.menuName}}</a>
								<a :name='menu.data.menuName' :text='menu.data.menuName' v-else href="javascript:void(0)" style='color:#c1c1c1;cursor:help'>{{menu.data.menuName}}</a>
								<sub-tree v-show='false' v-if='menu.children.length>0' :treedata='menu.children' :currentNodeName="currentNodeName"> 0' ></sub-tree>
							</li>
						</ul>`
		}
	}
}
</script>
<style>
.app-aside {
	height: 100%;
	padding-top: 65px;
	padding-bottom: 30px;
	float: left;
	background-color: #fff;
	overflow: auto;
    position: relative;
    padding-right: 0px;
    box-shadow: 0px 2px 19.6px 0.4px rgba(19,53,94,0.2);
    z-index: 2;
}

.app-aside .titleBar {
	text-align: left;
	height: 26px;
	line-height: 26px;
	font-size: 16px;
	margin: 10px 13px;
    box-sizing: content-box;
    font-family: 微软雅黑;
}
.app-aside .titleBar.jump{
    margin: 0px 0px;
    padding: 10px 13px 10px;
    box-sizing: content-box;
    border-bottom: 1px solid #f3f3f3;
    cursor: pointer
}
.app-aside .titleBar.jump:hover {
    color:#237ae4;
}
.app-aside.show-menu{
    display: block;
}
.app-aside.hide-menu {
	width: initial;
	min-width: 11px;
	left: 0;
}
.app-aside.hide-menu .tree-menu{
    display: none;
}

.tree-menu {
	height: auto;
	position: relative;
}

.tree-menu .fa {
	font-size: 16px;
}

.tree-menu .title {
	height: 40px;
	line-height: 40px;
	font-size: 20px;
	background-color: #fff;
	color: #333;
	padding-left: 20px;
	margin: 0;
	min-width: 220px;
}

.title .foldmenu {
	width: 39px;
	height: 40px;
	float: right;
	background: url("../../static/images/foldmenu.png") no-repeat center;
	cursor: pointer;
}

.tree-menu ul {
	padding: 0;
}

.tree-menu>ul {
	overflow-y: auto;
    border-top: 1px solid #f3f3f3;
}
.tree-menu>ul.jump{
    margin-bottom: 20px;
}
.tree-menu ul li a:hover {
	color: #237ae4;
	text-decoration: underline!important;
}
.tree-menu ul li ul li ul li,.tree-menu ul li ul li,.tree-menu ul li{

}
.tree-menu>ul>li {
	border-bottom: 1px solid #f3f3f3;
}
.tree-menu ul li a .icon{
    margin-right: 5px;
}
.tree-menu ul li a {
	display: inline-block;
	color: #41464a;
	height: 46px;
	line-height: 46px;
	min-width: 210px;
    font-size: 16px;
    margin-left: 13px;
    padding-right: 10px;
    font-family: 微软雅黑;
    box-sizing: border-box;
}
.tree-menu ul li ul li a{
    height: 41px;
    line-height: 41px;
}
.tree-menu ul li ul li ul li a{
    height: 38px;
    line-height: 38px;
}
.tree-menu>ul.jump>li>a {
    margin-left: 20px;
}
.tree-menu>ul>li>ul>li{
    width: 100%;
    margin-right: 20px;
}
.tree-menu>ul>li>ul>li>a {
	font-size: 14px;
    margin-left: 20px;
    padding-right: 0px;
}
.tree-menu>ul>li>ul>li>ul>li{
    width: 100%;
}
.tree-menu>ul>li>ul>li>ul>li>a {
	font-size: 14px;
    margin-left: 40px;
    padding-right: 0px;
}

.tree-menu>ul>li>ul>li>ul>li>ul>li>a {
	font-size: 12px;
	padding-left: 50px;
}

.tree-menu ul li,
.tree-menu ul li a:hover,
.tree-menu ul li a:focus {
	list-style: none;
	text-decoration: none;
	white-space: nowrap;
}


.tree-menu ul li a.router-link-active:focus,
.tree-menu ul li.active {
	list-style: none;
	background-color: #edf4ff;
	color: #237ae4;
    position: relative;
}

.tree-menu ul li.active a {
    color: #237ae4;
}
.tree-menu ul li ul li ul li.active:before{
    height: 38px;
}
.tree-menu ul li ul li.active:before{
    content: "";
    width: 5px;
    height: 41px;
    background-color: #237ae4;
    display: inline-block;
    position: absolute;
    left: 0px;
    top:0px;
    z-index: 1;
}

.tree-menu ul li .fa-link {
	font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// app_aside.vue?263596c2